import script from "./ShapeCreateCanvas.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapeCreateCanvas.vue?vue&type=script&lang=ts&setup=true"

import "./ShapeCreateCanvas.vue?vue&type=style&index=0&id=224f36be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-224f36be"]])

export default __exports__